import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/**
 * Старый URL /bitrix-tasks/:id → список с открытым Drawer справа.
 */
const BitrixTaskDetailPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            navigate(`/bitrix-tasks?task=${id}`, { replace: true });
        } else {
            navigate('/bitrix-tasks', { replace: true });
        }
    }, [id, navigate]);

    return null;
};

export default BitrixTaskDetailPage;
